import theme from "./Theme";

export default theme;
